export default {
    computed: {
        validation: function () {
            const isCostPerClick = _.get(this.adSet, 'type.id') === 3;

            return {
                name: !!this.adSet.name,
                nameUnique: _.indexOf(this.currentAdSetNames, this.adSet.name.trim().toLowerCase()) == -1,
                loan_purposes: !_.isEmpty(this.adSet.loan_purposes),
                budget_amount: !!this.isValidBudgetAmount,
                budget_interval: (!!this.adSet.budgets[0]['budget_interval'] && this.adSet.budgets[0]['budget_interval'] != 'none') || (!!this.adSet.id && !this.adSet.is_active),
                budget_end_not_after_start: this.adSet.end_date == '' || moment(this.adSet.start_date).isBefore(this.adSet.end_date, 'day'),
                schedule_day_ranges: !!this.isValidScheduleDayRanges,
                type: this.isMortgage && !this.editing ? !_.isEmpty(this.adSet.type) : true,
                schedule_timezone: !this.shouldUseSchedule || !this.featureFlag('ad-set-schedule-timezone') || (this.featureFlag('ad-set-schedule-timezone') && !_.isEmpty(this.adSet.schedule_timezone)),
                product_family_types: this.isMortgage ? !_.isEmpty(this.adSet.product_family_types) : true,
                device_types: !this.featureFlag('ad-set-device-types-enabled') || (this.featureFlag('ad-set-device-types-enabled') && !_.isEmpty(this.adSet.device_types)),
                landing_url: !this.featureFlag('ad-set-landing-url-enabled') || !isCostPerClick || this.adSet.creative_uuid || (this.featureFlag('ad-set-landing-url-enabled') && isCostPerClick && !!this.adSet.landing_url)
            };
        },

        isValidBudgetAmount: function () {
            return this.adSet.budgets.reduce(function (total, budget) {
                    return total + budget.budget;
                }, 0) > 0 ||
                this.adSet.budgets[0]['budget_interval'] == 9;
        },

        isValidScheduleDayRanges: function () {
            return this.adSet.schedule_day_ranges.reduce((carry, timeSlot) => {
                return timeSlot.day && timeSlot.start && timeSlot.end && carry;
            }, true)
        },

        isValid: function () {
            var validationFields = this.validationFields;
            var allFieldsAreValid = Object.keys(validationFields).every(function (key) {
                return validationFields[key];
            });

            if (!allFieldsAreValid) {
                return false;
            }

            var validation = this.validation;
            return Object.keys(validation).every(function (key) {
                return validation[key];
            });
        },

        shouldUseSchedule: function () {
            return _.get(this.adSet, 'type.id') === 2
                || this.userRoles.includes('staff')
                || this.userRoles.includes('engineer');
        }
    },

    watch: {
        'dateStart.time': function () {
            this.adSet.start_date = this.dateStart.time;
        },
        'dateEnd.time': function () {
            this.adSet.end_date = this.dateEnd.time;
        }
    },

    methods: {
        getCurrentNames: function (callback) {
            return this.$http.get(this.baseUrl + '/api/campaign/' + this.campaign.id + '/adsets/names').then(function (response) {
                if (response.body.success) {
                    this.currentAdSetNames = response.body.adSetNames;
                    if (typeof callback != 'undefined') callback();
                }
            });
        },

        getLoanSizes() {
            return this.$http.get(route('api.loan-size.index')).then((response) => {
                this.loanSizes = response.body.loanSizes;
            });
        },

        goBack: function () {
            this.redirect('/campaigns/' + this.campaign.id);
        },

        /* Utils */
        redirect: function (url) {
            window.location = url;
        },

        showErrorMsg: function (message) {
            $.loading.hide();
            this.showErrorMessage(message);
        },

        setValidation: function (field, status) {
            this.validationFields[field] = status;
        }
    }
};
